import { Theme } from '@blockanalitica/ui/package/types/src/theme/ThemeProvider';
import { ComponentStyle } from '@blockanalitica/ui/package/types/src/theme/types';

export function paginationContainer(theme: Theme): ComponentStyle {
  return {
    componentName: 'paginationContainer',
    baseStyle: {
      paddingBottom: theme.space['xs'],
      paddingLeft: theme.space['s'],
      paddingRight: theme.space['s']
    }
  };
}
